<template>
  <div>
    <!-- 居中 -->
    <div class="content" id="content">
      <!-- 竞赛动态 -->
      <div class="newsdetail" id="newsdetail">
        <p class="newstitle" id="newstitle">竞赛动态</p>
        <div class="newsdivide" id="newsdivide"></div>
        <div class="newscontain" id="newscontain">
          <div class="details">
            <div class="detailsinfo" id="detailsinfo">
              <!-- 右侧 -->
              <div class="leftcontain"></div>
              <newslist></newslist>
              <div class="rightcontain"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ElMessage } from "element-plus";
import newslist from "./newcontain/newlist"
export default {
  components: {
    newslist
  },
  data() {
    return {
      dataSource: {
        totalCount: 50,
        pageSize: 5,
        pageNo: 1,
      },
      menuList: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "文档",
          path: "/docs",
        },
        {
          name: "竞赛动态",
          path: "/about",
        },
        {
          name: "竞赛动态1",
          path: "/about1",
        },
        {
          name: "竞赛动态2",
          path: "/about2",
        },
        {
          name: "竞赛动态3",
          path: "/about3",
        },
      ],
      isPC: this.isPCNot(),
 
      /* 导航标题 */
      nevigatelist: [
        {
          id: "1",
          nav: "home",
          url: "/",
          label: "首页",
        },
        {
          id: "2",
          nav: "product",
          url: "/about",
          label: "关于大赛",
        },
        {
          id: "3",
          url: "/newsinfo",
          nav: "wechat",
          label: "竞赛动态",
        },
        {
          id: "4",
          nav: "solution",
          label: "往届赛事",
          url: "/precompetitions",
        },
        {
          id: "5",
          nav: "cooperate",
          url: "/learn",
          label: "学习专区",
        },
      ],
    };
  },
  methods: {
    //判断是否为PC
		isPCNot() {
            var userAgentInfo = navigator.userAgent;
            var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
    },
    changestyle(){
				//如果是安卓端
			  if(this.isPC==false){
					var newstitle = document.getElementById("newstitle").style; 
					newstitle.fontSize="1.2em"
          newstitle.paddingTop="0em"
          var newsdivide= document.getElementById("newsdivide").style; 
          newsdivide.height="1.5em"

          var content= document.getElementById("content").style; 
          content.width="95%"

          var detailsinfo=document.getElementById("detailsinfo").style; 
          detailsinfo.padding="5px 3px 2px 2px"
          detailsinfo.gridTemplateColumns="5% 93% 2%"
          var newscontain=document.getElementById("newscontain").style; 
          newscontain.marginLeft="0em"

          // for (var i=0;i<mainleftimg.length;i++){
          //   mainleftimg[i].style.width="7vw";
          //   mainleftimg[i].style.height="5vh";
					// }



					// var topa=document.getElementsByName('topa');
					// for (var i=0;i<topa.length;i++){
					// topa[i].style.padding="0 5px";
					// topa[i].style.height="4vh";
					// topa[i].style.fontSize="0.5em";
					// topa[i].style.marginTop="1.2em";
					// }
					// var toph2=document.getElementsByName('toph2');
        }
			},
  },
  mounted(){
    this.changestyle();
  },
  created() {
  },
  computed: {},
};
</script>
<style>
:-webkit-scrollbar {
  width: 5px;
  height: 14px;
}

::-webkit-scrollbar-thumb {
  background-color: #b6b6b6;
}
</style>
<style scoped>

.content {
  width: 80%;
  margin: 0px auto 0px auto;
  min-height: 150vh;
  /*background: url("../assets/divide.png") no-repeat;   no-repeat:背景图将不会被重复*/
}

.news {
  height: 85vh;
}

.newsinfo {
  display: grid;
  grid-template-columns: 5% 50% 0% 45%;
}

.competition {
  height: 70vh;
}

.newstitle {
  font-size: 2em;
  color: #1362db;
  font-weight: bold;
  height: 1.2em;
  padding-top: 1em;
  text-align:center;

}
.newsdivide {
  height: 3em;
  width: 100%;
  background: url("../assets/divide3.png") no-repeat;
  background-size: 100% 100%;
}

.study {
  height: 50vh;
  background-color: #7c7ca1;
}

.review {
  height: 90vh;
}

.qs {
  height: 75vh;
}

.footer {
  height: 30vh;
  background-color: #586885;text-align: center;
}

.demo-tabs >>> .el-tabs__item {
  font-size: 1.07em;
  font-family: "黑体";
}
.newscontain {
  width: 100%;
  min-height: 130vh;
  margin-left: 2em;
  background-color: #ffffff;
}
.carspic {
  position: relative;
  left: 21%;
  top: 34%;
  width: 40%;
  height: 70%;
  background: url("../assets/carmin.png") no-repeat;
  /*no-repeat:背景图将不会被重复*/
  background-size: cover;
  /*背景图片放大到适合元素容器的尺寸，图片比例不变.背景图像的某些部分可能无法显示在背景定位区域中。*/
}

.bigimg_1 {
  font: 800 70px/1 "Source Sans Pro", Arial, sans-serif;
  background: transparent;
  text-transform: uppercase;
  color: #ffffff;
  text-align: center;
  position: absolute;
  top: 15%;
  width: 97%;

  text-shadow: 0 1px 0 hsl(173, 11%, 85%), 0 2px 0 hsl(0, 0%, 84%),
    0 3px 0 hsl(174, 5%, 70%), 0 4px 0 hsl(174, 5%, 66%),
    0 5px 0 hsl(174, 5%, 64%), 0 6px 0 hsl(174, 5%, 62%),
    0 7px 0 hsl(174, 5%, 61%), 0 8px 0 hsl(174, 5%, 60%),
    0 0 5px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.2),
    0 3px 5px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.2),
    0 10px 10px rgba(0, 0, 0, 0.2), 0 20px 20px rgba(0, 0, 0, 0.3);
}

.footer {
  background-color: #444444;
  height: 100%;
  width: 100%;
  padding: 2vh 0;
}

.footer p {
  color: white;
  font-size: 16px;
  display: block;
  line-height: 38px;
}
.arrange {
  height: 54vh;
}
.bodys {
  background-color: #f9f9f9;
}
.ogh2 {
  position: absolute;
  width: 20vw;
  top: 30%;
  right: 29%;
  font-size: 1.7em;
  color: #a7aba9;
}
.logoimg {
  position: relative;
  width: 100%;
  height: 90%;
  top: 5%;
  background: url("../assets/logo.png") no-repeat;
  /*no-repeat:背景图将不会被重复*/
  background-size: 100% 100%;
}

.header {
  position: relative;
  z-index: 100;
  min-width: 1000px;
  height: 100%;
  display: grid;
  background: #2f83e5;
  grid-template-columns: 3% 12% 70% 8% 7%;
}

.logoh {
  position: relative;
  top: 30%;
  color: white;
}
.logos {
  display: grid;
  grid-template-columns: 30% 70%;
}
a:hover,
a:link,
a:visited,
a:active,
a:focus {
  color: ghostwhite;
  text-decoration: none;
}
.login {
  position: relative;
  top: 30%;
}
.newstitle {
  font-size: 2em;
  color: #1362db;
  font-weight: bold;
  height: 1.2em;
  padding-top: 1em;
  text-align:center;

}
.newsdivide {
  height: 3em;
  width: 100%;
  background: url("../assets/divide3.png") no-repeat;
  background-size: 100% 100%;
}
.detailsinfo {
  display: grid;
  grid-template-columns: 5% 85% 10%;
  width: 100%;
  margin: 0px auto 0px auto;
  padding-top: 1.5em;
}
.newscontain {
  width: 100%;
  min-height: 120vh;

  background-color: #ffffff;
}

.detailscenter {
  margin-left: 5vw;
}
.pagination {
  justify-content: center;
  align-items: center;
  margin-top: 5vh;
}
</style>
<style lang="scss" scoped>
a {
  text-decoration: none;
  color: black;
  .main-item {
    box-sizing: border-box;
    height: 17vh;
    width: 60vw;
    border-bottom: 1px solid #eee;
    padding: 30px 0;
    display: flex;
    .main-left {
      margin-right: 30px;
      width: 150px;
      flex: 0 0 150px;
      height: 100px;
      overflow: hidden;
      border-radius: 4px;
      img {
        width: 150px;
        height: 100px;
        transition: all 0.7s ease-in-out;
      }
    }
    .main-right {
      flex: 1;
      overflow: hidden;
      .introduce-head {
        display: flex;
        justify-content: space-between;
        .introduce-left {
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          .title {
            margin-right: 12px;
            font-size: 20px;
            color: #000;
            line-height: 24px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            float: left;
          }
        }
        .introduce-right {
          font-size: 14px;
          color: #666;
          line-height: 22px;
          .time {
            float: right;
          }
        }
      }
    }
    .content {
      margin-bottom: 12px;
      color: #999;
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      float: left;
    }
  }
}
</style>
